// src/uteis/mascaras/mascaraValor.js

/**
 * Aplica máscara para valor monetário no formato 1.234,56
 * Aceita entrada parcial.
 * 
 * Exemplo de uso:
 * 
 *  aplicarMascaraValor('1');         // "0,01"
    aplicarMascaraValor('12');        // "0,12"
    aplicarMascaraValor('123');       // "1,23"
    aplicarMascaraValor('1234');      // "12,34"
    aplicarMascaraValor('1234567');   // "12.345,67"
 */
export function aplicarMascaraValor(valor) {
  // Remove tudo que não seja dígito
  const apenasNumeros = valor.replace(/\D/g, '');

  if (apenasNumeros.length === 0) return '';

  // Converte para número inteiro representando centavos
  const numero = parseInt(apenasNumeros, 10);

  // Divide para obter reais e centavos
  const centavos = (numero / 100).toFixed(2) // força 2 casas
    .replace('.', ','); // vírgula para decimal

  // Adiciona separador de milhar
  return centavos.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
}
